import React from 'react';

import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from '@nhl/nhl-breakaway-ui';

import { statsConfigSelectors } from '../../../../../redux/ducks/config';
import { reportActionCreators } from '../../../../../redux/ducks/playersAndTeams/report';
import { commonMessages } from '../../../../../utility/commonMessages';

const SeasonFromSelect = () => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const statsConfig = useSelector((state) => state.config);
    const selectedSeasonFrom = useSelector((state) => state.playersAndTeams.report.current.seasonFrom);
    const selectedSeasonTo = useSelector((state) => state.playersAndTeams.report.current.seasonTo);

    const fromOptions = statsConfigSelectors.getSeasonsAsDropdownOptions(
        statsConfig,
        selectedSeasonFrom,
        selectedSeasonTo,
    );

    const handleSeasonFromChange = (e, { value }) => {
        dispatch(reportActionCreators.setSeasonFrom(value));
        dispatch(reportActionCreators.runReport());
    };

    return (
        <Select
            options={fromOptions}
            onOptionChange={handleSeasonFromChange}
            name="seasonFrom"
            selectedOption={fromOptions.find((obj) => obj.value === selectedSeasonFrom)}
            isSearchEnabled
            dropdownButtonAriaLabel={intl.formatMessage(commonMessages.filters.expandSeason)}
            optionsBoxAriaLabel={intl.formatMessage(commonMessages.filters.seasonFrom)}
        />
    );
};

export default SeasonFromSelect;
